import { MouseEvent, ReactElement, useCallback } from 'react';
import { ILinkProps, Link } from '@cars4ever/public-ui';
import { useNavigate } from 'react-router-dom';

export interface IRouterAwareLinkProps extends ILinkProps {}

const RouterAwareLink = ({ href, onClick, ...rest }: IRouterAwareLinkProps): ReactElement => {
  const navigate = useNavigate();

  const handleClick = useCallback(
    (event: MouseEvent<HTMLAnchorElement>): void => {
      if (!href) {
        return;
      }

      if (typeof onClick === 'function') {
        onClick(event);
      }

      try {
        new URL(href);
      } catch {
        event.preventDefault();

        // react-router v7's `navigate` returns a Promise; navigation is fire-and-forget here.
        void navigate(href);
      }
    },
    [href, navigate, onClick],
  );

  return (
    <Link
      href={href}
      onClick={handleClick}
      {...rest}
    />
  );
};

export default RouterAwareLink;
